import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BootstrapComponent } from './components/bootstrap/bootstrap.component';
import { StartComponent } from './components/start/start.component';

const routes: Routes = [
  { path: '', component: BootstrapComponent }, 
  { path: 'bootstrap', component: BootstrapComponent }, 
  { path: 'start', component: StartComponent }, 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EloquaRoutingModule { }
